import React, { useState, createContext, useEffect } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

export const WardrobeHeightContext = createContext();

const lsWardrobeHeight = reactLocalStorage.getObject('wardrobeHeight', 240);

export const WardrobeHeightProvider = ({ children }) => {
  const [wardrobeHeight, setWardrobeHeight] = useState(lsWardrobeHeight);

  useEffect(() => {
    if (typeof wardrobeHeight === 'number') {
      reactLocalStorage.setObject('wardrobeHeight', wardrobeHeight);
    }
  }, [wardrobeHeight]);

  return (
    <WardrobeHeightContext.Provider value={{ wardrobeHeight, setWardrobeHeight }}>
      {children}
    </WardrobeHeightContext.Provider>
  );
};
